import { render, staticRenderFns } from "./PBDSearch.vue?vue&type=template&id=0ef0f12c&scoped=true&"
import script from "./PBDSearch.vue?vue&type=script&lang=js&"
export * from "./PBDSearch.vue?vue&type=script&lang=js&"
import style0 from "./PBDSearch.vue?vue&type=style&index=0&id=0ef0f12c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef0f12c",
  null
  
)

export default component.exports